<div class="mat-dialog-container">
  <div class="mat-dialog-header">
    <div class="mat-dialog-title">
      Import Students: {{ customRoster.name }}
    </div>
    <fa-icon (click)="dialogRef.close()" [icon]="['fas', 'close']"></fa-icon>
  </div>
  <div mat-dialog-content>
    <div class="banner">
      <app-warning-banner-component bannerIcon="info-circle"
        bannerClass="custom-banner-container info-banner-container vertical-padding">
        <span class="banner-text">
          <b>Upload CSV. Ensure the first column contains Student IDs, and include a header.</b>
        </span>
      </app-warning-banner-component>
    </div>
    <app-file-upload [allowedExtensions]="allowedFileExtensions" [maxMBFileSize]="10"
      (fileChanged)="handleFileChanged($event)">
    </app-file-upload>
    <div class="import-modal-nav">
      <button class="outline-button standard-button" mat-button type="button" (click)="dialogRef.close()">
        Cancel
      </button>
      <button class="secondary-button standard-button upload-button" mat-button (click)="uploadFile()"
        type="button" [disabled]="!this.file">
        Import students
      </button>
    </div>
  </div>
</div>